module.exports = __webpack_public_path__ + "static/img/hbr.1e3fe64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/old/hbr.png
// module id = e/7H
// module chunks = 0